import {toCurrency, toPoints} from '@/shared/helpers'
export const TABLE_COLUMNS = [
  {
    Header: "Program Name",
    accessor: "program_name",
  },
  {
    Header: "Program Id",
    accessor: "program_id",
  },
  {
    Header: "External Id",
    accessor: "external_id",
  },
  {
    Header: "Event",
    accessor: "event_name",
  },
  {
    Header: "Date",
    accessor: "posting_timestamp",
  },
  {
    id: 'to',
    Header: () => (<div style={{textAlign: 'center', borderTop: '1px solid #ccc', paddingTop: 6}}>To</div>),
    className: 'align-center',
    Footer: "",
    columns: [
      {
        Header: "First Name",
        accessor: "recipient_first_name",
        width: 100
      },
      {
        Header: "Last Name",
        accessor: "recipient_last_name",
        width: 100
      },
      {
        Header: "Email",
        accessor: "recipient_email",
      }
    ]
  },
  {
    Header: "From",
    accessor: data => (
      data.awarder_full
    ),
    width: 120
  },
  {
    Header: "Referrer",
    accessor: "referrer",
  },
  {
    Header: "Notes",
    accessor: "notes",
  },
  {
    Header: "Value",
    accessor: "points",
    Cell: ({ row, value }) => { return toPoints(value); },
    width: 70
  },
  {
    Header: "Dollar Value",
    accessor: "dollar_value",
    Cell: ({ row, value }) => { return toCurrency(value); },
    width: 110
  },
];
